import React, { useState } from 'react';
import { FlexBox } from '@/common/components/Box/FlexBox.tsx';
import { Segment } from '@/types/types.ts';
import Popover from '@mui/material/Popover';
import ColorSwatches from "@/common/components/ColorSwatches/ColorSwatches.tsx";

interface SegmentColorCellProps {
  segment: Segment;
  onChangeColor?: (id: string, color: string) => void;
}

export const SegmentColorCell: React.FC<SegmentColorCellProps> = ({ segment, onChangeColor }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeComplete = (color: { hex: string }) => {
    if (onChangeColor) {
      onChangeColor(segment.id as string, color.hex);
    }
    handleClose();
  };

  const open = Boolean(anchorEl);
  const id = open ? 'color-popover' : undefined;

  return (
    <div>
      <FlexBox
        className="segment-color-cell"
        width={1}
        sx={{
          backgroundColor: segment.color as string,
          float: 'left',
          height: '35px',
          marginLeft: '-11px',
          position: 'relative',
          width: 5,
          paddingLeft: 0,
          borderLeft: `10px ${(segment.color as string)} solid`,
        }}
        onClick={handleClick}
      />
      <Popover
        id={id}
        slotProps={{
          paper: {
            sx: {
              borderRadius: 3,
              overflow: 'hidden',
              maxWidth: "525px",
              maxHeight: "80px",
              padding: "7px 10px",
              // bgcolor: 'background.level3',
            }
          }
        }}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <ColorSwatches
          color={segment.color as string}
          handleColorChange={handleChangeComplete}
        />
      </Popover>
    </div>
  );
};
